import * as React from 'react';

export const useCallbackRef = <T>(initialRef?: T | (() => T)) => {
	const [ref, setRef] = React.useState<T>(initialRef);
	return [
		ref,
		React.useCallback(
			(obj?: T) => {
				if (ref !== obj) {
					setRef(obj);
				}
			},
			[ref]
		),
	] as const;
};
